// extracted by mini-css-extract-plugin
export default {"notification":"lucky-loore-registration-form_notification__xI5fR","submit-button":"lucky-loore-registration-form_submit-button__bnW0g"};